(ns bedrock-ui.sentry.handlers
  (:require #?(:clj  [clj-time.core :as time]
               :cljs [cljs-time.core :as time])
            [re-frame.core :as rf]
            [bedrock-ui.sentry.db :as sentry-db]
            [bedrock-ui.sentry.fx :as fx]))

(rf/reg-event-fx
 ::capture-message
 (fn capture-message
   [{:keys [db]} [_ message]]
   {::fx/capture-message message}))

(defn- report-dialog-shown-recently?
  [{:keys [now db] :as cofxs}]
  (boolean
    (when-let [last-shown-time (sentry-db/get-report-dialog-last-shown db)]
      (time/after? (time/plus last-shown-time (time/minutes 10)) now))))

(rf/reg-event-fx
 ::show-report-dialog
 [(rf/inject-cofx :now)]
 (fn show-report-dialogue
   [{:keys [db now] :as cofxs} [_ user]]
   (when-not (report-dialog-shown-recently? cofxs)
     {:db (sentry-db/set-report-dialog-last-shown db now)
      ::fx/show-report-dialogue user})))

(rf/reg-event-fx
 ::init
 (fn init
   [{{{:keys [version]} :config} :db} [_ {:keys [sentry]}]]
   {::fx/init (assoc sentry :release version)}))
